// extracted by mini-css-extract-plugin
module.exports = {"bodywrapper":"boersepage_bodywrapper__2MyBz","bodywrapper3":"boersepage_bodywrapper3__2LT6m","logo":"boersepage_logo__e_-oJ"};